import api from "./api";

/* ================= QUESTIONS ================= */

// Add question to quiz
export function addQuestion(data) {
    return api.post("/question", data);
}

export const reorderQuestion = (id, direction) => {
    return api.put(`/question/${id}/reorder`, { direction });
}

export function getQuestions(page = 1, limit = 10, search = "") {
    return api.get(`/question?page=${page}&limit=${limit}&search=${search}`);
}

export function getUserAttempts(page = 1, limit = 10, search = "") {
    return api.get(`/question/attempts?page=${page}&limit=${limit}&search=${search}`);
};

export function getUserAnswersByAttempt(params) {
    return api.get("/question/answers", { params });
};

export function getQuestionById(id) {
    return api.get(`/question/${id}`);
}

// Delete question
export function deleteQuestion(id) {
    return api.delete(`/question/${id}`);
}

/* ================= OPTIONS ================= */
// Delete option
export function deleteOption(id) {
    return api.delete(`/question/option/${id}`);
}
